import { User } from 'firebase/auth';
import { doc, getDoc } from "firebase/firestore";

import { db } from '../Database/Firebase.service';
import { TAuthData } from '../../Contexts/AuthContext/AuthProvider.type';

export const getUserRole = async (uid: string): Promise<{hasRole: boolean, role: 'Admin' | 'User'}> => {
    try {
        const firestore = db;
        const userDocRef = doc(firestore, "Users", uid);
        const userRoleDoc = await getDoc(userDocRef);
    
        if(userRoleDoc.exists() === false){
            console.error('Erro ao obter permissao do Usuario');
        }
    
        const docData = userRoleDoc.data();
    
        if(!docData || docData.hasOwnProperty('role') === false ){
            throw new Error('Permissoes do usuario nao localizadas.')
        }
        const role: 'Admin' | 'User' = docData.role;
    
        return {hasRole: true, role};
    } catch (error) {
        console.error(error);
        return {hasRole: false, role: 'User'};
    };
}

export const getUserData = async ({ uid, email }: User): Promise<TAuthData> => {
    try {
        const firestore = db;
        const userDocRef = doc(firestore, "Users", uid);
        const userRoleDoc = await getDoc(userDocRef);
    
        if(userRoleDoc.exists() === false){
            console.error('Erro ao obter permissao do Usuario');
        }
    
        const docData = userRoleDoc.data();
    
        if(!docData){
            throw new Error('Informações do usuario nao localizadas.')
        }

        const {hasRole, role} = await getUserRole(uid);
        const displayName = docData.displayName;
        if(hasRole === false){
            throw new Error('Permissoes do usuario nao localizadas.');
        }

        const userData = {
            uid,
            displayName,
            email,
            role
        };

        return userData;
    } catch (error) {
        throw error;
    }
}